<template>
  <div class="align-center d-flex">
    <v-icon
      v-if="showIcon"
      :class="params.classes"
      :disabled="params.isDisabled"
      :size="iconSize"
      color="primary"
      class="icon-min-width pr-1"
      style="min-width: 18px !important"
      >{{ iconName }}</v-icon
    >
    <span :style="{ paddingLeft: !showIcon && addSpaceToTextValue ? '18px !important' : 0 }">{{
      textValue
    }}</span>
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  computed: {
    iconSize() {
      return get(this.params, 'size', 18);
    },

    showIcon() {
      return get(this.params, 'value.showIcon', false);
    },

    iconName() {
      return get(this.params, 'value.iconName', 'mdi-star');
    },

    textValue() {
      return get(this.params, 'value.textValue');
    },

    addSpaceToTextValue() {
      return get(this.params, 'value.addSpaceToTextValue', false);
    },
  },

  methods: {},
};
</script>
